import React, { useEffect, useRef } from "react";
import { useLang } from "../i18n/LangContext";
import "../components/MobilePhone.css";

const Screen1: React.FC = () => {
  const { t } = useLang();
  const s = t.screens.s1;
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const notifs = wrapRef.current?.querySelectorAll(".notif");
    notifs?.forEach((n) => {
      const el = n as HTMLElement;
      el.classList.remove("show");
      setTimeout(() => el.classList.add("show"), Number(el.dataset.delay || 0));
    });
  }, []);

  const people = [
    { name: "Anne", time: "now", delay: 300 },
    { name: "Janne", time: "1m", delay: 1400 },
    { name: "Timo", time: "3m", delay: 2500 },
    { name: "Sanna", time: "6m", delay: 3600 },
  ];

  return (
    <div className="mobile-screen-page" ref={wrapRef}>
      <div className="mobile-wrap">
        <div className="phone">
          <div className="phone-screen">
            <div className="notch" />
            <div className="statusbar">
              <div>09:41</div>
              <div>78%</div>
            </div>
            <div className="phone-content">
              <div className="lock-time">09:41</div>
              <div className="lock-sub">{s.lockSub}</div>
              <div className="notif-wrap">
                {people.map((n, i) => (
                  <div className="notif" data-delay={n.delay} key={i}>
                    <div className="app-icon">W</div>
                    <div className="notif-body">
                      <div className="notif-top">
                        <div>Worklly</div>
                        <div className="notif-time">{n.time}</div>
                      </div>
                      <div className="notif-title">{s.notifTitle}</div>
                      <div className="notif-text">
                        <strong>{n.name}</strong> {s.notifText}
                      </div>
                      <div className="notif-badge">{s.notifBadge}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="home-indicator" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Screen1;
